import { Reveal, MaskLines, Label, ImageReveal } from "./Reveal-graphics";

const CHAIN = ["Farmer", "Geography", "Process", "Coffee", "Moment"];

const SEQUENCE = [
  { src: "https://images.unsplash.com/photo-1650884986695-d1e5cf90610f?q=80&w=1200&auto=format&fit=crop", alt: "Coffee landscape in morning mist" },
  { src: "https://images.unsplash.com/photo-1782973752125-f22b5c4c7346?q=80&w=1200&auto=format&fit=crop", alt: "Ripening coffee cherries on the plant" },
  { src: "https://images.unsplash.com/photo-1790492486342-5058f2637317?q=80&w=1200&auto=format&fit=crop", alt: "Hands holding freshly harvested coffee cherries" },
  { src: "https://images.unsplash.com/photo-1729277133095-bff46b56c29a?q=80&w=1200&auto=format&fit=crop", alt: "Finished filter coffee" },
];

export default function About() {
  return (
    <section id="about" className="relative py-28 md:py-40" data-testid="about-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <Label>04 — About</Label>

        <div className="mt-10 grid md:grid-cols-12 gap-14 md:gap-8">
          <div className="md:col-span-5">
            <h2 className="font-serif font-normal text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-[-0.005em]">
              <MaskLines lines={[<em key="i" className="italic text-forest">Why Anichya?</em>]} />
            </h2>

            <Reveal delay={0.15}>
              <p className="mt-12 font-serif text-2xl md:text-3xl text-ink leading-snug" data-testid="about-chain-intro">
                A coffee does not begin in a cup.
              </p>
            </Reveal>

            <div className="mt-10" data-testid="about-chain">
              {CHAIN.map((c, i) => (
                <Reveal key={c} delay={i * 0.08}>
                  <p className="font-serif italic text-xl md:text-2xl text-brown">{c}</p>
                  {i < CHAIN.length - 1 && (
                    <p className="text-terracotta text-sm my-1.5 ml-1" aria-hidden="true">↓</p>
                  )}
                </Reveal>
              ))}
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7 space-y-9 text-base md:text-lg leading-relaxed text-smoke">
            <Reveal>
              <div className="font-serif text-xl md:text-2xl leading-relaxed text-ink" data-testid="about-begins">
                <p>It begins with a place.</p>
                <p>With the people who grow it.</p>
                <p>With the landscape around them.</p>
                <p>With the choices made through the harvest and processing.</p>
                <p>With the particular conditions of a particular season.</p>
                <p className="mt-5">By the time coffee reaches the cup, all of those things have become part of it.</p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <p>
                Anichya is about paying attention to that chain of moments. Not trying to make
                every coffee the same. But understanding what makes this coffee, from this
                place, at this time, what it is.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="font-serif italic text-xl md:text-2xl text-forest leading-snug" data-testid="about-ending">
                Because what exists today will not exist in quite the same way tomorrow.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {SEQUENCE.map((im, i) => (
            <Reveal key={im.src} delay={i * 0.1}>
              <ImageReveal
                src={im.src}
                alt={im.alt}
                className="aspect-[4/5]"
                delay={i * 0.08}
                testid={`about-image-${i}`}
                imgClassName="hover:scale-[1.03] transition-transform duration-[1400ms] ease-out"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
